import React, { FC} from 'react'
import { Col, Rate, Row } from 'antd';
import styled from 'styled-components'
import { ExpertText, MediumHeaderTitle } from '../Text3D';
// import { PrimaryButton } from '../Button3D';
import {useParams } from 'react-router-dom';
import { GET_SINGLE_PRINTER } from '../../Apollo/graphql/Query';
import { useQuery } from '@apollo/client';
import Ultimaker from '../../assets/images/ultimaker.png';

const ContentSection = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
`
const ImageSection = styled.div`
    display: flex;
    height: 360px;
    justify-content: center;
    align-items: center;
    width: 100%;
    border: 1px solid #D8D8D8;
    margin: 1rem 0;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
`;
// const Img = styled.img`
//     margin: 1rem auto;

// `;
const Img = styled.img`
  margin: 1rem auto;
  display: inline-block;
  max-width: 100%;
  height: 100%;
`
const ThumbnailImgSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`
const ThumbnailImgWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D8D8D8;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
    height: 122px;
    width: 114px;
`
const ThumbnailImg = styled.img`
    height: 80px;
    width: 70px;
`;
const RightContentSection = styled.div`
    width: 100%;
    background: white;
    padding: 2rem;
`;
const ContentDiv = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
    padding-bottom: 2rem;
`
const SpanX = styled.span`
    margin-left: 1rem;
`
const RatingDiv = styled.div`
    display: flex;
    border-top: 1px solid #D8D8D8;
    border-bottom: 1px solid #D8D8D8;
    height: 50px;
    align-items: center;
`
const SectionX = styled.section`
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    color: #75706B;
    display: flex;
`

const PrinterDescription: FC = () => {
    // const history = useHistory();
    const { id } = useParams<{ id?: string }>();

    const { data,} = useQuery(GET_SINGLE_PRINTER, {
        variables: {
            printerId: id
        }
    });
    return (
      <div>
        <Row style={{ borderBottom: "1px solid #D8D8D8", background: "white" }}>
          <Col span={9}>
            <ContentSection>
              <ImageSection>
                <Img src={data?.printer?.featuredImage} alt="" />
              </ImageSection>
              <ThumbnailImgSection>
                <ThumbnailImgSection>
                  <ThumbnailImgWrapper>
                    <ThumbnailImg src={Ultimaker} alt=""></ThumbnailImg>
                  </ThumbnailImgWrapper>
                  <ThumbnailImgWrapper>
                    <ThumbnailImg src={Ultimaker} alt=""></ThumbnailImg>
                  </ThumbnailImgWrapper>
                  <ThumbnailImgWrapper>
                    <ThumbnailImg src={Ultimaker} alt=""></ThumbnailImg>
                  </ThumbnailImgWrapper>
                </ThumbnailImgSection>
              </ThumbnailImgSection>
            </ContentSection>
          </Col>
          <Col span={15}>
            <RightContentSection>
              <ContentDiv>
                <MediumHeaderTitle dark fontSize>
                  <strong>{data?.printer.name}</strong>
                </MediumHeaderTitle>
                <ExpertText dark>
                  <strong>Brand:</strong>
                  <SpanX>{data?.printer.brand}</SpanX>
                </ExpertText>
                <ExpertText dark>
                  <strong>Printer Dimensions LxWxH:</strong>
                  <SpanX>
                    {data?.printer.length} x {data?.printer.width} x{" "}
                    {data?.printer.height}
                  </SpanX>
                </ExpertText>
                {/* <ExpertText dark><strong>Printer Weight:</strong><SpanX>{data?.printer.weight} Kilograms</SpanX></ExpertText> */}
                <ExpertText dark>
                  <strong>Filaments:</strong>
                  <SpanX>
                    {data?.printer?.filaments &&
                      data?.printer.filaments.map((mat) => (
                        <div>
                          <SpanX>
                            {mat.name} - ${mat.price} per gram
                          </SpanX>
                        </div>
                      ))}
                  </SpanX>
                </ExpertText>
                <ExpertText dark>
                  <strong>Price:</strong>
                  <SpanX>{data?.printer.price} per mm3</SpanX>
                </ExpertText>
                <RatingDiv>
                  <SectionX>
                    <strong style={{ paddingTop: ".2rem" }}>Rating:</strong>
                    <SpanX>
                      <Rate defaultValue={3} disabled></Rate>
                    </SpanX>
                    <SpanX style={{ paddingTop: ".2rem" }}>7 Ratings</SpanX>
                  </SectionX>
                </RatingDiv>
              </ContentDiv>
            </RightContentSection>
          </Col>
        </Row>
      </div>
    );
}

export default PrinterDescription;